import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import ApiRequest from "./ApiRequest";

const PermissionContext = createContext({ status: "loading", currentUser: null, permissionSlugs: new Set(), hasPermission: () => false });
export const usePermissions = () => useContext(PermissionContext);

export function PermissionProvider({ children }) {
  const [status, setStatus] = useState("loading");
  const [currentUser, setCurrentUser] = useState(null);
  const [permissionSlugs, setPermissionSlugs] = useState(new Set());
  const refreshPermissions = useCallback(async () => {
    try {
      const response = await ApiRequest("GET", "api/rbac/my-permissions");
      setCurrentUser(response.user || null);
      setPermissionSlugs(new Set((response.permissions || []).map((permission) => permission.slug)));
      setStatus("ready");
    } catch (error) {
      if (error.response?.status === 401) setStatus("unauthorized");
      else if (error.response?.status === 403) { setPermissionSlugs(new Set()); setStatus("ready"); }
    }
  }, []);
  useEffect(() => {
    refreshPermissions();
    const interval = setInterval(refreshPermissions, 10000);
    window.addEventListener("focus", refreshPermissions);
    return () => { clearInterval(interval); window.removeEventListener("focus", refreshPermissions); };
  }, [refreshPermissions]);
  const value = useMemo(() => ({
    status, currentUser, permissionSlugs,
    hasPermission: (slug) => permissionSlugs.has(slug), refreshPermissions,
  }), [status, currentUser, permissionSlugs, refreshPermissions]);
  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
}
